import React from 'react';
import { useStoreState } from '@discover-data/stores/restaurant/hooks';
import { objectLength } from '@discover-lib/utils';
import Label from '@discover-ui/label';
import AbortTestButton from './abortTestButton';
import EnabledSwitch from './enabledSwitch';
import Metric from './metric';
import ModeToggles from './modeToggles';
import Paging from './paging';

export default function State() {
  const restaurantsById = useStoreState((state) => Object.entries(state.byId.value)); // using the `[...]` method to convert the `entries` iterator to an array as apposed to the `.toArray()` method since it's not fully supported on all browsers
  const ids = useStoreState((state) => state.allIds.value);
  const restaurantsLoading = useStoreState((state) => state.allIds.loading || state.byId.loading);
  const inViewById = useStoreState((state) => state.inViewById);

  const discountAvailabilityById = useStoreState((state) => state.discountAvailabilityById);
  const firebaseAllAvailabilityById = useStoreState((state) => state.firebaseAllAvailability.byId);
  const loadingFirebaseAllAvailability = useStoreState(
    (state) => state.firebaseAllAvailability.loading
  );
  const allAvailabilitySubscriptions = useStoreState(
    (state) => state.firebaseAllAvailability.firebase.unsubsByPath
  );

  const loading = useStoreState((state) => state.loading);
  const idsToShow = useStoreState((state) => state.idsToShow);

  return (
    <div className="flex flex-col items-stretch gap-2">
      <div className="flex flex-row items-center gap-2">
        <EnabledSwitch />
        <ModeToggles />
      </div>

      <Label className="m-0">Restaurants</Label>
      <Metric
        name="restaurantsById"
        loading={restaurantsLoading}
        data={restaurantsById}
        count={restaurantsById.length}
      />
      <Metric name="ids" loading={restaurantsLoading} data={ids} count={ids.length} />
      <Metric
        name="inView"
        loading={false}
        data={Object.keys(inViewById)}
        count={objectLength(inViewById)}
      />

      <Label className="m-0">Discount Availability</Label>
      <Metric
        name="discountAvailabilityById"
        loading={loadingFirebaseAllAvailability}
        data={discountAvailabilityById}
        count={objectLength(discountAvailabilityById)}
      />
      <Metric
        name="firebaseAllAvailability"
        loading={loadingFirebaseAllAvailability}
        data={firebaseAllAvailabilityById}
        count={objectLength(firebaseAllAvailabilityById)}
      />
      <Metric
        name="firebase.subscriptions"
        loading={loadingFirebaseAllAvailability}
        data={Object.keys(allAvailabilitySubscriptions)}
        count={objectLength(allAvailabilitySubscriptions)}
      />

      <Label className="m-0">To Show</Label>
      <Metric name="idsToShow" loading={loading} data={idsToShow} count={idsToShow.length} />

      <Paging />

      <Label>Tests</Label>
      <AbortTestButton />
    </div>
  );
}
